import React from 'react';
import * as GoodReadsSelector from '../../data/GoodReadsSelector';
import CardContainer from 'react/containers/CardContainer';
import ReaderReviews from '../views/readerReviews/ReaderReviews';
import { getFullTitle } from '../../data/FullTitleSelector';
import { getJsonData } from '../../data/DataStore';

const ReaderReviewsContainer = (props) => {
	let reviewsModel = GoodReadsSelector.getGoodReads();
	let fullTitle = getFullTitle(getJsonData());     	

	if(reviewsModel && !reviewsModel.isInGoodReads)
		reviewsModel = null;
	
	return (
		<CardContainer cardName="Reader Reviews" cardModel={reviewsModel} component={ReaderReviews} fullTitle={fullTitle} {...props}/>		
	);
}
export default ReaderReviewsContainer;



// WEBPACK FOOTER //
// ./src/react/containers/ReaderReviewsContainer.jsx